import { analytics } from '../firebase';
import { logEvent } from 'firebase/analytics';

// Custom event tracking functions
export const trackPageView = (pageName) => {
  if (analytics) {
    logEvent(analytics, 'page_view', {
      page_title: pageName,
      page_location: window.location.href
    });
  }
};

export const trackReservationCreated = (reservationData) => {
  if (analytics) {
    logEvent(analytics, 'reservation_created', {
      duration: reservationData.duration,
      numberOfPeople: reservationData.numberOfPeople,
      racketsNeeded: reservationData.racketsNeeded,
      totalPrice: reservationData.totalPrice,
      date: reservationData.date,
      time: reservationData.time
    });
  }
};

export const trackUserLogin = (method) => {
  if (analytics) {
    logEvent(analytics, 'login', {
      method: method // 'email', 'google', 'anonymous'
    });
  }
};

export const trackUserSignup = (method) => {
  if (analytics) {
    logEvent(analytics, 'sign_up', {
      method: method
    });
  }
};

export const trackCalendarNavigation = (direction) => {
  if (analytics) {
    logEvent(analytics, 'calendar_navigation', {
      direction: direction // 'previous_week', 'next_week'
    });
  }
};

export const trackSlotClick = (date, time, status) => {
  if (analytics) {
    logEvent(analytics, 'slot_click', {
      date: date,
      time: time,
      status: status // 'available', 'booked', 'unavailable'
    });
  }
};

export const trackAdminAction = (action, details = {}) => {
  if (analytics) {
    logEvent(analytics, 'admin_action', {
      action: action,
      ...details
    });
  }
};

// Set user properties for better analytics
export const setUserProperties = (properties) => {
  if (analytics) {
    // Note: setUserProperties is not available in Firebase v9+
    // User properties are automatically tracked based on user authentication
    console.log('User properties would be set:', properties);
  }
}; 